/* eslint-disable complexity */
import React from 'react';
import headingSchema from '../../../lib/composer/schemas/heading';
import subheadingSchema from '../../../lib/composer/schemas/subheading';
import textSchema from '../../../lib/composer/schemas/text';
import { ctaSchema, ctasSchema } from '../../../lib/composer/schemas/cta';
import themeSchema from '../../../lib/composer/schemas/theme';
import { Box } from '@osmosis/react-ui/components/Box';
import { Flex } from '@osmosis/react-ui/components/Box';
import { useColors } from '@osmosis/react-ui/hooks/useColors';
import Subheading from '../block-ui/Subheading';
import Heading from '../block-ui/Heading';
import CTAs from '../block-ui/CTAs';
import RichText from '../block-ui/RichText';
import { ComposerBlockElement, TextProps } from '../../../types/composer';
import BlockWrapper from '../BlockWrapper';
/**
 * Text banner block.
 */
const Text: ComposerBlockElement = (props: TextProps) => {
  const {
    heading,
    subheading,
    text,
    cta: ctaProps,
    ctas: ctasProps,
    theme = 'bg-0',
    topHeader,
  } = props;

  const colors = useColors();

  const bg = colors[theme];
  const ctas = [...(ctaProps?.caption ? [ctaProps] : []), ...(ctasProps || [])];

  return (
    <Box bg={bg}>
      <BlockWrapper>
        <Box p={3} maxWidth={1000} m="auto">
          <Flex
            flex={1}
            alignItems="center"
            flexDirection="column"
            sx={{ gap: 3 }}
          >
            {!!heading && (
              <Heading text={heading} theme={theme} topHeader={topHeader} />
            )}
            {!!subheading && (
              <Subheading
                text={subheading}
                theme={theme}
                topHeader={topHeader}
              />
            )}
            {!!text && (
              <RichText
                html={text}
                theme={theme}
                alignment="center"
                containerProps={{
                  sx: {
                    maxWidth: 'unset',
                    textAlign: 'unset',
                  },
                }}
              />
            )}

            <CTAs ctas={ctas} theme={theme} />
          </Flex>
        </Box>
      </BlockWrapper>
    </Box>
  );
};

Text.schema = {
  name: 'text',
  label: 'Text',
  editableProps: [
    headingSchema,
    subheadingSchema,
    textSchema,
    ctaSchema,
    ctasSchema,
    themeSchema,
  ],
};

export default Text;
